import DocumentErrorList from "../components/document-errors/DocumentErrorCrud";

const DocumentErrorPage = () => {
  return <DocumentErrorList />;
};

export default DocumentErrorPage;
